<div class="bread-crumb-container">
  <h2 class="margin-0">Edit Profile</h2>
</div>
<div class="global-container" [ngStyle]="{'overflow':'auto'}">
  <div class="container-fluid">
    <cdk-accordion class="container-fluid" multi = "true" [ngStyle]="{'margin-top':'20px'}">
        <cdk-accordion-item
          #accordionItemOne="cdkAccordionItem"
          class="example-accordion-item acc-separator"
          role="button"
          tabindex="0"
          [attr.id]="'accordion-header-' + 1"
          [attr.aria-expanded]="accordionItemOne.expanded"
          [attr.aria-controls]="'accordion-body-' + 1">
          <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemOne.toggle()">
            <h3 class="margin-0">Biographical Information</h3>
            <span class="example-accordion-item-description">
              <mat-icon class="cmmn-icn-color">{{ accordionItemOne.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
            </span>
          </div>
          <div
            class="example-accordion-item-body"
            role="region"
            [style.display]="accordionItemOne.expanded ? '' : 'none'"
            [attr.id]="'accordion-body-' + 1"
            [attr.aria-labelledby]="'accordion-header-' + 1">
              <form [formGroup]="bioGraphicalInformation">
                <div class="d-flex flex-wrap">
                  <mat-form-field  class="m-2 col-2 example-full-width">
                   <mat-label>*First Name</mat-label>
                    <input matInput formControlName="firstName" type="text">
                    <mat-error *ngIf = "bioGraphicalInformation['controls']['firstName'].errors?.required">First name is required</mat-error>
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                  <mat-form-field  class="m-2 col-2 example-full-width">
                    <mat-label>*Last Name</mat-label>
                    <input matInput formControlName="lastName"type="text">
                    <mat-error *ngIf = "bioGraphicalInformation['controls']['lastName'].errors?.required">Last name is required</mat-error>
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                  <mat-form-field  class="m-2 col-2 example-full-width">
                    <mat-label>*Phone Number</mat-label>
                    <input matInput formControlName="phno" type="text" mask="(000) 000-0000">
                    <mat-error *ngIf = "bioGraphicalInformation['controls']['phno'].errors?.required">Phone number is required</mat-error>
                    <mat-error *ngIf = "bioGraphicalInformation['controls']['phno'].errors?.minlength">Enter 10 digit phone number</mat-error>
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                  <mat-form-field  class="m-2 col-5 example-full-width">
                    <mat-label>*Timezone</mat-label>
                    <mat-select disableOptionCentering panelClass="common-drop-down-class" formControlName="timeszone" class="body-font-size">
                      <ng-container >
                          <mat-option *ngFor="let tz of tzNames" [value]="tz.code" (click)="timeZoneValue(tz.description)">{{tz.description}}</mat-option>
                      </ng-container>
                  </mat-select>
                 </mat-form-field>
                </div>
                <div class="d-flex justify-content-end">
                  <button mat-raised-button type="submit" color = "primary" [ngStyle]="{'margin-right':'5px'}" class="text-uppercase" (click)="saveEditProfile()">Save</button>
                  <button mat-raised-button type="reset" class="text-uppercase" color = "primary">Reset</button>
                </div>
              </form>
          </div>
        </cdk-accordion-item>
        <cdk-accordion-item
          #accordionItemTwo ="cdkAccordionItem"
          class="example-accordion-item acc-separator"
          role="button"
          tabindex="1"
          [attr.id]="'accordion-header-' + 2"
          [attr.aria-expanded]="accordionItemTwo.expanded"
          [attr.aria-controls]="'accordion-body-' + 2">
          <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemTwo.toggle()">
            <h3 class="margin-0">Security Question</h3>
            <span class="example-accordion-item-description">
              <mat-icon class="cmmn-icn-color">{{ accordionItemTwo.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
            </span>
          </div>
          <div
            class="example-accordion-item-body"
            role="region"
            [style.display]="accordionItemTwo.expanded ? '' : 'none'"
            [attr.id]="'accordion-body-' + 2"
            [attr.aria-labelledby]="'accordion-header-' + 2">
              <form [formGroup] = "securityQuetsionForm">
                <div class="">
                  <div  formArrayName="questionContainer">
                  <div class="d-flex flex-wrap"  *ngFor = "let item of employees.controls; let i = index" [formGroupName]="i" >
                    <mat-form-field  class="p-2 example-full-width col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <mat-label>Security Question {{i + 1}}</mat-label>
                      <mat-select disableOptionCentering panelClass="common-drop-down-class" id = "{{i}}+dpdown" (selectionChange) = "changeTracker($event, i)"  formControlName = "questions" >
                        <mat-option [disabled] = "disabledSelectedItems(items.quesCode)" *ngFor = "let items of secQuesResponse; let j = index"   (click)="changeDetection(items,i)" id ={{items.quesCode}}  value={{items.quesCode}}>{{items.quesDesc}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field  class="p-2 example-full-width col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <mat-label>Answer {{i + 1}}</mat-label>
                      <input matInput type="password" matInput formControlName = "answers" [ngClass]="{ 'is-invalid': isSubmitted && f.answers.errors }">
                    </mat-form-field>
                  </div>
                </div>
                  <div>
                    <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'auto'}">
                      <mat-label>*Password</mat-label>
                      <input matInput type="password" formControlName="password">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button mat-raised-button type="submit" color = "primary" [ngStyle]="{'margin-right':'5px'}" class="text-uppercase" (click)="saveSecQues()">Save</button>
                    <button mat-raised-button type="reset" color = "primary" class="text-uppercase">Reset</button>
                  </div>
                </div>
              </form>
          </div>
        </cdk-accordion-item>
        <cdk-accordion-item
        #accordionItemThree ="cdkAccordionItem"
        class="example-accordion-item acc-separator"
        role="button"
        tabindex="2"
        [attr.id]="'accordion-header-' + 3"
        [attr.aria-expanded]="accordionItemThree.expanded"
        [attr.aria-controls]="'accordion-body-' + 3">
        <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemThree.toggle()">
          <h3 class="margin-0">Change Password</h3>
          <span class="example-accordion-item-description">
            <mat-icon class="cmmn-icn-color">{{ accordionItemThree.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
            <!-- Click to  -->
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemThree.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 3"
          [attr.aria-labelledby]="'accordion-header-' + 3">
            <form [formGroup]="newPasswordForm">
              <div class="d-flex flex-wrap">
                <mat-form-field  class="m-2 col-4 example-full-width">
                  <mat-label>*Old Password</mat-label>
                  <input matInput formControlName="oldPassword" type="password">
                  <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
                <mat-form-field  class="m-2 col-4 example-full-width">
                  <mat-label>*New Password</mat-label>
                  <input matInput formControlName="newPassword" type="password">
                  <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
                <mat-form-field  class="m-2 col-3 example-full-width">
                  <mat-label>*Confirm Password</mat-label>
                  <input matInput formControlName="confirmPassword" type="password">
                  <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
              <div class="d-flex justify-content-end">
                <button mat-raised-button type="submit" color = "primary" [ngStyle]="{'margin-right':'5px'}" (click)="saveNewPassword()" class="text-uppercase">Save</button>
                <button mat-raised-button type="reset" color = "primary" class="text-uppercase">Reset</button>
              </div>
            </form>
        </div>
        </cdk-accordion-item>
        <!-- <cdk-accordion-item
        #accordionItemFour ="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="3"
        [attr.id]="'accordion-header-' + 4"
        [attr.aria-expanded]="accordionItemFour.expanded"
        [attr.aria-controls]="'accordion-body-' + 4">
        <div class="example-accordion-item-header" (click)="accordionItemFour.toggle()">
          <h3 class="margin-0">Web Link</h3>
          <span class="example-accordion-item-description">
            <mat-icon>{{ accordionItemFour.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemFour.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 4"
          [attr.aria-labelledby]="'accordion-header-' + 4">
            <div class="d-flex">
              <div class="col-lg-6 text-start">
                <a>Web Launcher Link</a>
              </div>
              <div class="col-lg-6">
                <button mat-raised-button type="submit" color = "primary">Copy link to clipboard</button>
              </div>
            </div>
        </div>
        </cdk-accordion-item> -->
        <!-- <cdk-accordion-item
        #accordionItemFive ="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="4"
        [attr.id]="'accordion-header-' + 5"
        [attr.aria-expanded]="accordionItemFive.expanded"
        [attr.aria-controls]="'accordion-body-' + 5">
        <div class="example-accordion-item-header" (click)="accordionItemFive.toggle()">
          <h3 class="margin-0">Agora Notepad executable file download</h3>
          <span class="example-accordion-item-description">
            <mat-icon>{{ accordionItemFive.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemFive.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 5"
          [attr.aria-labelledby]="'accordion-header-' + 5">
            <div class="d-flex">
              <div class="col-lg-6 text-start">
                <a>Download this in case Windows</a>
              </div>
              <div class="col-lg-6">
                <button mat-raised-button type="submit" color = "primary">Download - Windows 64 bit(.exe)</button>
              </div>
            </div>
            <div class="d-flex">
              <div class="col-lg-6 text-start">
                <a>Download this in case Linux</a>
              </div>
              <div class="col-lg-6">
                <button mat-raised-button type="submit" color = "primary">Download - Linux 64 bit</button>
              </div>
            </div>
            <div>
              <h4>(Please provide a username, password of your Agora login credentials, and use the service URL as 'https://agora.aithent.com/agora/' while logging to Agora Notepad when window prompts.)</h4>
            </div>
        </div>
        </cdk-accordion-item> -->
        <!-- <cdk-accordion-item
        #accordionItemSix ="cdkAccordionItem"
        class="example-accordion-item"
        role="button"
        tabindex="5"
        [attr.id]="'accordion-header-' + 6"
        [attr.aria-expanded]="accordionItemSix.expanded"
        [attr.aria-controls]="'accordion-body-' + 6">
        <div class="example-accordion-item-header" (click)="accordionItemSix.toggle()">
          <h3 class="margin-0">Web Conference Preference</h3>
          <span class="example-accordion-item-description">
            <mat-icon>{{ accordionItemSix.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemSix.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 6"
          [attr.aria-labelledby]="'accordion-header-' + 6">
          <form>
            <div class="d-flex">
              <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                <mat-label>*Provide Jitsi join URL</mat-label>
                <input matInput [formControl]= "jitsiUrl" type="text">
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-end">
              <button mat-raised-button type="submit" color = "primary" [ngStyle]="{'margin-right':'5px'}" (click)="saveWebPreference()">Save</button>
              <button mat-raised-button type="reset" color = "primary">Reset</button>
            </div>
          </form>
        </div>
        </cdk-accordion-item> -->
        <cdk-accordion-item
        #accordionItemSeven ="cdkAccordionItem"
        class="example-accordion-item acc-separator"
        role="button"
        tabindex="6"
        [attr.id]="'accordion-header-' + 7"
        [attr.aria-expanded]="accordionItemSeven.expanded"
        [attr.aria-controls]="'accordion-body-' + 7">
        <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemSeven.toggle()">
        <h3 class="margin-0">Personal Calendar</h3>
        <span class="example-accordion-item-description">
          <mat-icon class="cmmn-icn-color">{{ accordionItemSeven.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
        </span>
        </div>
        <div
        class="example-accordion-item-body"
        role="region"
        [style.display]="accordionItemSeven.expanded ? '' : 'none'"
        [attr.id]="'accordion-body-' + 7"
        [attr.aria-labelledby]="'accordion-header-' + 7">
          <div>
            <h4>Please configure the following service URL into your Google Calendar settings under the Share with specific people section in order to synchronize the meeting events from Agora to Google Calendar automatically. The service URL is 'google-calendarapi&#64;graphic-adapter-293806.iam.gserviceaccount.com</h4>
          </div>
          <form [formGroup]=personalCalendar>
            <div class="d-flex flex-wrap">
              <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'auto'}">
                <mat-label>*Calendar Type</mat-label>
                <mat-select  disableOptionCentering panelClass="common-drop-down-class" formControlName="calendarType" >
                  <mat-option  (blur)="fetchUserCalInfo()" *ngFor=" let calType of calendarTypes" [value]="calType.code">{{calType.description}}
                  </mat-option>
                </mat-select>
                <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
              </mat-form-field>
              <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'auto'}">
                <mat-label>*User Name</mat-label>
                <input id="username" matInput formControlName="userMail" type="text">
                <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-end">
              <button mat-raised-button type="submit" color = "primary" [ngStyle]="{'margin-right':'5px'}" class="text-uppercase" (click)="savePersonalCalendar()">Save</button>
              <button mat-raised-button type="reset" color = "primary" class="text-uppercase">Reset</button>
            </div>
          </form>
        </div>
        </cdk-accordion-item>
        <cdk-accordion-item
        #accordionItemEight ="cdkAccordionItem"
        class="example-accordion-item acc-separator"
        role="button"
        tabindex="7"
        [attr.id]="'accordion-header-' + 8"
        [attr.aria-expanded]="accordionItemEight.expanded"
        [attr.aria-controls]="'accordion-body-' + 8">
        <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemEight.toggle()">
        <h3 class="margin-0">Zoom Integration  <span *ngIf="isZoomDisabled" [ngStyle]="{'color':'green'}">(Synced with Zoom)</span></h3>
        <span class="example-accordion-item-description">
          <mat-icon class="cmmn-icn-color">{{ accordionItemEight.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
        </span>
        </div>
        <div
        class="example-accordion-item-body"
        role="region"
        [style.display]="accordionItemEight.expanded ? '' : 'none'"
        [attr.id]="'accordion-body-' + 8"
        [attr.aria-labelledby]="'accordion-header-' + 8">
        <form [formGroup]="zoomIntegration">
          <div class="d-flex flex-wrap" *ngIf="isZoomDisabled">
            <mat-form-field  class="m-2 col-4 example-full-width">
              <mat-label>*Zoom Email</mat-label>
              <input matInput formControlName="zoomEmail" id="zoomEmail" type="text">
              <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
            </mat-form-field>
            </div>
           <div>
            <button disabled="{{isZoomDisabled}}" mat-raised-button color = "primary" ><a  [ngStyle]="{'color':'white'}" (click)="connectZoom()">Connect with Zoom</a></button>
          </div>
        </form>
        </div>
        </cdk-accordion-item>
    </cdk-accordion>
  </div>
</div>
